import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="py-20 bg-white" data-id="element-130">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-131">
        <FadeIn data-id="element-132">
          <p className="text-lg md:text-xl text-[#2D2A26] leading-relaxed mb-8" data-id="element-133">
            Si tienes más de 50 años, probablemente hayas notado que las reglas
            del juego han cambiado. Comes lo mismo de siempre, vas al gimnasio y
            te cuidas, pero tu abdomen sigue hinchado. Te despiertas plana, pero
            terminas el día sintiéndote como un globo, con la ropa que te
            aprieta y una pesadez que te quita las ganas de salir.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-134">
          <p className="text-lg md:text-xl text-[#2D2A26] leading-relaxed mb-8" data-id="element-135">
            No es que te falte voluntad. Es que a los 50 años, tu enemigo no son
            las calorías, es el cortisol y la inflamación post-menopausia. Tu
            cuerpo ya no responde a las dietas restrictivas; de hecho, pasar
            hambre solo hace que tu vientre se hinche más como mecanismo de
            protección.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-136">
          <div className="p-8 bg-[#E8EDE6] rounded-2xl border-l-4 border-[#4A6741]" data-id="element-137">
            <p className="text-lg md:text-xl text-[#2D2A26] font-medium leading-relaxed italic" data-id="element-138">
              He diseñado el Protocolo Vientre Plano 50+ para romper este ciclo.
              No es una dieta milagro, es un manual de instrucciones biológico
              para resetear tu sistema digestivo y calmar tus hormonas en solo 7
              días.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}